// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ivzU","content":"styles_content__3jFJb"};